export const SMALL_DENSITY_THRESHOLD = 5
export const MEDIUM_DENSITY_THRESHOLD = 10

export const DENSITY_CHART_CONFIGS: {
    threshold: number
    config: {maxBarThickness: number; categoryPercentage: number; barPercentage: number}
}[] = [
    {
        threshold: SMALL_DENSITY_THRESHOLD,
        config: {maxBarThickness: 50, categoryPercentage: 0.8, barPercentage: 0.6}
    },
    {
        threshold: MEDIUM_DENSITY_THRESHOLD,
        config: {maxBarThickness: 40, categoryPercentage: 0.7, barPercentage: 0.6}
    }
]

export const DEFAULT_CHART_CONFIG = {
    maxBarThickness: 50,
    categoryPercentage: 0.8,
    barPercentage: 0.6
}
